/**
    index js file
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { ENV , localDev } from "./modules/configs";
import { Provider } from 'react-redux';
import combinedReducer from './reducers';
import { createStore, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';
import './css/global.css';


switchLogger();
console.log('Application in', global.env === ENV.DEV ? 'Development' : global.env === ENV.STAGING ? 'Staging' : 'Production', 'Mode');

const store = createReduxStore();

const connectedApp = <Provider store={store}><App/></Provider>;

ReactDOM.render(connectedApp, document.getElementById('root'));
registerServiceWorker();


function switchLogger() {
  if (!window.console) {
    return;
  }

  if (localDev) {
    return;
  }
  console.log = function () {};
}

function createReduxStore() {
  return createStore(combinedReducer, {}, getComposedEnhancers());

  function getComposedEnhancers() {
    if (window.navigator.userAgent.includes('Chrome') && window.__REDUX_DEVTOOLS_EXTENSION__) {
      return compose(
        applyMiddleware(
          thunk
        ),
        window.__REDUX_DEVTOOLS_EXTENSION__()
      )
    } else {
      return compose(
        applyMiddleware (
          thunk
        )
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/index.js